module.exports = __webpack_public_path__ + "media/images/village/golden-ticket-2022/icons-4c643bd1275a77448930b6a238237b2b.svg";